module.exports = __webpack_public_path__ + "img/social_media.22462135.svg";